import { useQuery } from "@tanstack/react-query";
import { ControleQuinquennalApi } from "../controle-quinquennal.api";
import { controleQuinquennalKeys } from "./controle-quinquennal.keys";

export const useCQAxeRemediationsQuery = (
  idControleQuinquennal: string,
  idAxe: string,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: controleQuinquennalKeys.remediationsByAxe(
      idControleQuinquennal,
      idAxe
    ),
    queryFn: () =>
      ControleQuinquennalApi.getRemediationByAxeId(
        idControleQuinquennal,
        idAxe
      ),
    enabled: (options?.enabled ?? true) && !!idControleQuinquennal && !!idAxe,
  });
};
